var isType = require('./isType');

module.exports = function isUnion(x) {
  return isType(x) && ( x.meta.kind === 'union' );
};


//////////////////
// WEBPACK FOOTER
// ../~/tcomb/lib/isUnion.js
// module id = 946
// module chunks = 1